import { Tab } from './tab';
import { UserEvents } from 'shared/consts';
import { VisitUiType } from 'store/visits/types';
import { Wrapper } from './tabs.styles';
import { track } from '@hqo/web-tracking';
import { useIntl } from 'react-intl';

function trackPastVisitClick() {
  track(UserEvents.PAST_VISIT_CLICK, { type: 'action' }, { sendToPendo: true, sendToHqoTracking: true });
}
/*
 * Navigation between two pages, not a tab widget: links with the router's aria-current on the active
 * one, grouped in a named nav landmark. No tab/tablist roles.
 */
export const Tabs = (): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper as="nav" aria-label={formatMessage({ id: 'labels.visitorRegistration' })}>
      <Tab type={VisitUiType.UPCOMING} />
      <Tab type={VisitUiType.PAST} onClick={trackPastVisitClick} />
    </Wrapper>
  );
};
